import PropTypes from "prop-types";

export default PropTypes.shape({
  isRecruiter: PropTypes.bool,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  avatar: PropTypes.string,
  companyName: PropTypes.string,
  location: PropTypes.string,
  yearsExperience: PropTypes.number,
  contact: PropTypes.shape({
    email: PropTypes.string.isRequired,
    phone: PropTypes.string.isRequired,
    facebook: PropTypes.string,
    linkedin: PropTypes.string,
    instagram: PropTypes.string,
  }),
  verified: PropTypes.bool,
  new: PropTypes.bool,
  score: PropTypes.shape({
    starRatingPercentage: PropTypes.number.isRequired,
  }),
});
